<template>
  <accordion :id="accordionId" :group="accordionGroup" v-if="isEnabled">
    <template v-slot:trigger>
      <span class="icon-pita sw--margin-right-3 sw--font-size-20"></span>
      <span>Print it anyway (PITA)</span>
    </template>
    <template v-slot:target>
      <div
        class=" sw--margin-left-7 sw--margin-left-0--tab sw--margin-bottom-2 sw-dms--color-grey-46">
        We will print what you've designed, but this does mean that your 3D printed part may be in an imperfect state
        when delivered. More information about Print it anyway can be found through our
        <a
          href="https://www.shapeways.com/faq"
          title="How does 'Print It Anyway' work?"
          target="_blank">Help Center</a>.
      </div>
      <div class="sw--margin-bottom-7 sw--margin-left-7 sw--margin-left-0--tab">
        <div v-if="errorMessage"
             class="model-fix-error-box
            sw-grid-flex__cell
            sw-grid-flex
            sw-grid-flex--align-center
            sw--padding-4
            sw--bg-alert-red-lightest
            sw--border-radius-3
            sw--margin-vert-2">
          <div class="icon-how-it-works sw--font-size-28 sw--margin-right-3 sw--text-red"></div>
          <div>
            {{ errorMessage }}
          </div>
        </div>
        <a
          class="sw-dms-button sw-dms-button--big"
          @click.prevent="displayModal(modalText)">
          <span class="sw-dms--color-grey-46">
              Print it anyway
          </span>
        </a>
      </div>
    </template>
  </accordion>
</template>

<script>
  import VueJQueryMixin from 'js/lib/vue/mixins/vue-jquery-mixin';
  import VueSwMixin from 'js/lib/vue/mixins/vue-sw-mixin';
  import confirmTemplate from 'rrViewComponents/Model/Fix/ModelFixPitaComponent/confirm-pita-noty.mustache';
  import Accordion from "rrViewComponents/Accordion/Accordion";

  export default {
    name: 'model-fix-pita',

    components: {Accordion},

    mixins: [VueJQueryMixin, VueSwMixin],

    props: {
      enabled: {
        type: Boolean,
        required: true
      },
      url: {
        type: String
      },
      accordionId: {
        type: String,
        required: true
      },
      accordionGroup: {
        type: String,
        required: true
      }
    },

    data: () => ({
      modalText: 'Are you sure you would like to convert this model to Print it Anyway? You will not be eligible for a refund if the model arrives broken.',
      errorMessage: null
    }),

    computed: {
      isEnabled() {
        return this.enabled && this.url && this.url.length;
      }
    },

    // TODO: same code as in model-fix-cancel-order-items, refactor when we know how to pass more than one var to noty
    methods: {
      displayModal(content) {
        const _this = this;
        if (_this.isEnabled) {
          _this.errorMessage = null;
          let confirmed = false;
          let $confirmBtn = null;
          _this.$sw.notifications.full(content, {
            modal: true,
            layout: 'center',
            template: confirmTemplate,
            closeWith: ['button', 'backdrop'],
            showCloseButton: true,
            callback: {
              afterShow: function () {
                $confirmBtn = _this.$jQuery('[data-sw-noty-confirm-btn]');
                $confirmBtn.on('click', function () {
                  confirmed = true;
                })
              },
              afterClose: function () {
                if ($confirmBtn) {
                  $confirmBtn.off('click');
                }
                if (confirmed) {
                  _this.submitModal();
                }
              }
            }
          });
        }
      },
      submitModal() {
        if (this.isEnabled) {
          const _this = this;
          this.$jQuery.ajax({
            type: 'POST',
            url: _this.url,
            dataType: 'json',
            success: (data) => {
              _this.$emit('success', data);
            },
            error: (jqXHR) => {
              const response = JSON.parse(jqXHR.responseText);
              _this.errorMessage = response.message;
              _this.$emit('error', response);
            }
          });
        }
      }
    }
  }
</script>
